module.exports = __webpack_public_path__ + "img/product_index_icon2.8aa2c04e.png";